import { Button } from "@narmi/design_system";
import styles from "./TransferPill.module.scss";

type TransferPill = {
  redirect: string;
  label: string;
};

const TransferPill = ({ redirect, label }: TransferPill) => {
  // Always use absolute path for navigation
  const handleClick = () => {
    window.location.assign(redirect);
  };

  return (
    <div className={styles.pillWrapper}>
      <Button
        label={label}
        kind="tonal"
        size="s"
        style={{ borderRadius: "9999px" }}
        onClick={handleClick}
      />
    </div>
  );
};

export default TransferPill;
